import { Alert } from 'antd';
import { useVerifications } from '../hooks/use-verifications';
import type { WorkOrderPermissions } from '../hooks/use-work-order-permissions';
import { verifierRefusal } from '../policies/verifier-eligibility.policy';
import type { WorkOrderTransitionView, WorkOrderView } from '../work-orders.api';
import { VerificationAttempts } from './VerificationAttempts';
import { VerificationForm } from './VerificationForm';
import { VerificationPrompt } from './VerificationPrompt';

interface VerificationTabProps {
  order: WorkOrderView;
  transitions: WorkOrderTransitionView[];
  permissions: WorkOrderPermissions;
  onRecorded: () => Promise<void>;
}

/** A second person checks the finished work before the truck goes back on the road. Someone who raised or worked on the order is told so up front; the server still decides, and also refuses anyone who logged labour. */
export function VerificationTab({ order, transitions, permissions, onRecorded }: VerificationTabProps) {
  const { state, error, submitting, submit } = useVerifications(order, onRecorded);
  const refusal = verifierRefusal({ currentUserId: permissions.userId ?? '', raisedById: order.raisedById, transitions });

  if (state.status === 'forbidden') return <Alert type="info" showIcon title="You don't have access to verifications" />;
  if (state.status === 'error') return <Alert type="error" showIcon title="Couldn't load the verifications" />;

  return (
    <div className="flex flex-col gap-6">
      <VerificationPrompt
        orderState={order.state}
        canManage={permissions.canManage}
        refusal={refusal}
        form={<VerificationForm workOrderId={order.id} error={error} submitting={submitting} onSubmit={submit} />}
      />
      {state.status === 'loaded' && <VerificationAttempts attempts={state.attempts} />}
    </div>
  );
}
